<div
  *ngIf="sellers.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header">
  <table
    mat-table
    [dataSource]="sellers"
    class="sp-width__full">
    <ng-container matColumnDef="seller_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'SELLERS.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <app-shared-id
          [content]="seller.seller_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.REGISTRATION_DATE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <span class="sp-color__primary sp-text__ellipsized"> {{ seller.created_at | date : 'short' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="last_login">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.LAST_LOGIN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <span
          *ngIf="seller.last_login_at"
          class="sp-color__primary sp-text__ellipsized">
          {{ seller.last_login_at | date : 'short' }}
        </span>

        <span *ngIf="!seller.last_login_at">-</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.NAME_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <span
          *ngIf="seller.firstname && seller.lastname"
          class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ getFullName(seller).length > 30 ? (getFullName(seller) | slice : 0 : 30) + '...' : getFullName(seller) }}
        </span>
        <span *ngIf="!seller.firstname || !seller.lastname"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="company_business_name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.COMPANY_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <span class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ seller.company_business_name || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.PHONE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <div class="sp-row__align">
          <span class="sp-color__primary sp-text__white-space-nowrap">
            {{ seller.phone.prefix }}
            {{ seller.phone.value }}
          </span>

          <button
            (click)="onSetPhoneClick(seller); $event.stopPropagation()"
            mat-icon-button
            [matTooltip]="'SELLERS.EDIT_CTA_PHONE' | translate">
            <mat-icon class="sp-color__accent"> create </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.EMAIL_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ seller.email }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="is_confirmed">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'SELLERS.CONFIRMED_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <div class="sp-row__align sp-row__justify-center">
          <mat-icon
            [ngClass]="{
              'sp-color__green': seller.is_confirmed,
              'sp-color__red': !seller.is_confirmed && seller.password_set_at === 0,
              'sp-color__orange': !seller.is_confirmed && seller.password_set_at !== 0
            }"
            [matTooltip]="
              seller.is_confirmed
                ? ('GENERAL.TOOLTIP_CONFIRMED' | translate)
                : seller.password_set_at === 0
                ? ('GENERAL.TOOLTIP_NOT_CONFIRMED_NO_PASSWORD' | translate)
                : ('GENERAL.TOOLTIP_NOT_CONFIRMED_PASSWORD_SET' | translate)
            ">
            check_circle
          </mat-icon>
          <button
            (click)="onConfirmSellerClick(seller); $event.stopPropagation()"
            *ngIf="!seller.is_confirmed && seller.password_set_at !== 0"
            mat-icon-button
            class="sp-icon__button sp-icon__button-dark sp-margin__left"
            [matTooltip]="'SELLERS.CONFIRM_USER_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> check_circle_outline </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <!--<ng-container matColumnDef="mfa">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.PREFERRED_MFA_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ seller.preferred_mfa || 'SMS' | uppercase }}
        </span>
      </td>
    </ng-container>-->S

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <button
          mat-icon-button
          class="sp-icon__button sp-icon__button-dark sp-margin__left"
          [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate">
          <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
        </button>

        <button
          (click)="$event.stopPropagation()"
          mat-icon-button
          class="sp-icon__button sp-icon__button-accent sp-margin__left"
          [matTooltip]="'Menu' | translate"
          [mat-menu-trigger-for]="sellers_actions_menu">
          <mat-icon> more_horiz </mat-icon>
        </button>

        <mat-menu #sellers_actions_menu="matMenu">
          <button
            (click)="onEditClick(seller); $event.stopPropagation()"
            class="sp-padding__vert"
            mat-menu-item>
            <mat-icon class="material-symbols-outlined sp-color__accent"> create </mat-icon>
            <span> {{ 'SELLERS.EDIT_CTA' | translate }} </span>
          </button>

          <button
            (click)="onStoresClick(seller); $event.stopPropagation()"
            class="sp-padding__vert"
            mat-menu-item>
            <mat-icon class="material-symbols-outlined sp-color__accent"> storefront </mat-icon>
            <span> {{ 'SHARED.TOOLBAR_STORES_LABEL' | translate }} </span>
          </button>

          <button
            (click)="onSetMfaClick(seller); $event.stopPropagation()"
            class="sp-padding__vert"
            mat-menu-item>
            <mat-icon class="material-symbols-outlined sp-color__accent"> security_key </mat-icon>
            <span> {{ 'SELLERS.RESET_MFA_CTA' | translate }} </span>
          </button>

          <button
            (click)="onUnlockSellerClick(seller); $event.stopPropagation()"
            [disabled]="!seller.blocked_at"
            class="sp-padding__vert"
            mat-menu-item>
            <mat-icon class="material-symbols-outlined sp-color__accent"> lock_open</mat-icon>
            <span> {{ 'GENERAL.UNBLOCK_USER_CTA' | translate }} </span>
          </button>

          <button
            (click)="onInfoClick(seller); $event.stopPropagation()"
            [disabled]="!(seller.is_confirmed && seller.confirmed_by)"
            class="sp-padding__vert"
            mat-menu-item>
            <mat-icon class="material-symbols-outlined sp-color__accent"> info </mat-icon>
            <span> {{ 'SELLERS.CONFIRM_USER_CTA' | translate }} </span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayed_columns"
      class="sp-cursor__pointer"
      (click)="onDetailsClick(row)"></tr>
  </table>
</div>
